import React, { Component } from 'react';
import { connect } from 'react-redux';

import FormattedDate from '../fields/dates/FormattedDate';
import FormattedCurrencyValue from '../fields/number/FormattedCurrencyValue';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import Logger, {LOG_LEVELS} from '../../utils/logger';
import { withFullStoryExclude } from '../../utils/fullStoryHelper';

const log = new Logger('TRANSACTION_INVOICE_PROPERTIES', LOG_LEVELS.DEBUG);


class InvoiceProperties extends Component {

  render() {
    log.debug('render(): ', this.props);

    if (!this.props.invoiceProperties) {
      return(
        <div><LanguageStringResolver string='transactionBlank_noData'/></div>
      )
    }

    return(
      <div>
        {/* Supplier and customer */}
        <table className="mb50">
          <thead>
            <tr>
              <th colSpan="2"><LanguageStringResolver string='transactionInvoice_supplier'/></th>
              <th colSpan="2"><LanguageStringResolver string='transactionInvoice_customer'/></th>
            </tr>
          </thead>
          <tbody className="mb50">
            <tr>
              <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_supplierName'/></p></td>
              <td><p>{this.props.invoiceProperties.supplierName}</p></td>
              <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_customerName'/></p></td>
              <td><p>{this.props.invoiceProperties.customerName}</p></td>
            </tr>
            <tr>
              <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_supplierCode'/></p></td>
              <td><p>{this.props.invoiceProperties.supplierCode}</p></td>
              <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_customerCode'/></p></td>
              <td><p>{this.props.invoiceProperties.customer}</p></td>
            </tr>
            <tr>
              <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_supplierVATNumber'/></p></td>
              <td><p>{this.props.invoiceProperties.vatNumberUsedBySupplier}</p></td>
              <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_customerVATNumber'/></p></td>
              <td><p>{this.props.invoiceProperties.vatNumberUsedByCustomer}</p></td>
            </tr>
          </tbody>
        {/* Document details */}
          <thead>
            <tr>
              <th colSpan="4" className="pb5 pt50"><LanguageStringResolver string='transactionInvoice_documentDetails'/></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_invoiceDate'/></p></td>
              <td><p><FormattedDate value={this.props.invoiceProperties.invoiceDate}/></p></td>
              <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_originalTransactionDate'/></p></td>
              <td><p><FormattedDate value={this.props.originalTransactionDate}/></p></td>
            </tr>
            <tr>
              <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_invoiceNumber'/></p></td>
              <td><p>{this.props.invoiceProperties.invoiceNumber}</p></td>
              <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_exchangeRateDate'/></p></td>
              <td><p><FormattedDate value={this.props.invoiceProperties.exchangeRateDate}/></p></td>
            </tr>
            <tr>
              <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_supplierInvoiceNumber'/></p></td>
              <td><p>{this.props.invoiceProperties.invoiceNumberSupplier}</p></td>
              <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_invoiceReceiptDate'/></p></td>
              <td><p><FormattedDate value={this.props.invoiceProperties.invoiceReceiptDate}/></p></td>
            </tr>
            <tr>
              <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_documentType'/></p></td>
              <td><p>{this.props.invoiceProperties.documentType} - {this.props.invoiceProperties.documentType_str}</p></td>
              <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_processingDate'/></p></td>
              <td><p><FormattedDate value={this.props.processingDate} format='yyyy-mm-dd HH:MM:ss:l'/></p></td>
            </tr>
            <tr>
              <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_additionalDocumentType'/></p></td>
              <td><p>{this.props.invoiceProperties.additionalDocumentType}</p></td>
              <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_clearingDate'/></p></td>
              <td><p><FormattedDate value={this.props.clearingDate}/></p></td>
            </tr>
            <tr>
              <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_SAPDocumentType'/></p></td>
              <td><p>{this.props.invoiceProperties.sapDocumentType}</p></td>
              <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_clearingDocumentNumber'/></p></td>
              <td><p>{this.props.clearingDocNo}</p></td>
            </tr>
            <tr>
              <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_SAPReferenceDocument'/></p></td>
              <td><p>{this.props.invoiceProperties.sapReferenceDocument}</p></td>
              <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_clearingInfo'/></p></td>
              <td><p>{this.props.clearingInfo}</p></td>
            </tr>
            <tr>
              <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_transactionDate'/></p></td>
              <td><p><FormattedDate value={this.props.transactionDate}/></p></td>
              <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_originalInvoiceNumber'/></p></td>
              <td><p>{this.props.invoiceProperties.originalInvoiceNumber}</p></td>
            </tr>
            <tr>
              <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_documentId'/></p></td>
              <td><p>{this.props.documentId}</p></td>
              <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_originalInvoiceDate'/></p></td>
              <td><p>{this.props.invoiceProperties.originalInvoiceDate}</p></td>
            </tr>
            <tr>
              <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_ownReference'/></p></td>
              <td><p>{this.props.ownReference}</p></td>
              <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_originalDocumentType'/></p></td>
              <td><p>{this.props.invoiceProperties.originalDocumentType != '-1' ? this.props.invoiceProperties.originalDocumentType : ''}</p></td>
            </tr>
            <tr>
              <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_autofatturaNumber'/></p></td>
              <td><p>{this.props.invoiceProperties.autofatturaNumber}</p></td>
              <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_attachedDocument'/></p></td>
              <td><p>{this.props.attachedDoc}</p></td>
            </tr>
            <tr>
                <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_documentIndicator'/></p></td>
                <td><p>{this.props.invoiceProperties.documentIndicator}</p></td>
            </tr>
          </tbody>
        </table>

        {/* Document Totals */}
        <h2 className="mt30"><LanguageStringResolver string='transactionInvoice_documentTotals'/></h2>
        <table className="width-fit-content">
          <thead>
            <tr>
              <th><LanguageStringResolver string='transactionInvoice_totalValue'/></th>
              <th><LanguageStringResolver string='transactionInvoice_totalValueExcludingVAT'/></th>
              <th><LanguageStringResolver string='transactionInvoice_commission'/></th>
              <th><LanguageStringResolver string='transactionInvoice_currency'/></th>
            </tr>
          </thead>
          <tbody>
            <tr className={withFullStoryExclude()}>
              <td><p className="semi-bold"><FormattedCurrencyValue value={this.props.invoiceProperties.totalValue}/></p></td>
              <td><p className="semi-bold"><FormattedCurrencyValue value={this.props.invoiceProperties.totalValueExclVAT}/></p></td>
              <td><p className="semi-bold"><FormattedCurrencyValue value={this.props.invoiceProperties.commission}/></p></td>
              <td><p className="semi-bold">{this.props.invoiceProperties.currency}</p></td>
            </tr>
            <tr className={withFullStoryExclude()}>
              <td><p className="semi-bold"><FormattedCurrencyValue value={this.props.invoiceProperties.totalValue2}/></p></td>
              <td><p className="semi-bold"><FormattedCurrencyValue value={this.props.invoiceProperties.totalValueExclVAT2}/></p></td>
              <td><p className="semi-bold"><FormattedCurrencyValue value={this.props.invoiceProperties.commission2}/></p></td>
              <td><p className="semi-bold">{this.props.invoiceProperties.currency2}</p></td>
            </tr>
            <tr className={withFullStoryExclude()}>
              <td><p className="semi-bold"><FormattedCurrencyValue value={this.props.invoiceProperties.totalValue3}/></p></td>
              <td><p className="semi-bold"><FormattedCurrencyValue value={this.props.invoiceProperties.totalValueExclVAT3}/></p></td>
              <td><p className="semi-bold"><FormattedCurrencyValue value={this.props.invoiceProperties.commission3}/></p></td>
              <td>  <p className="semi-bold">{this.props.invoiceProperties.currency3}</p></td>
            </tr>
          </tbody>
        </table>
      </div>
   );
  }

}

function mapStateToProps(state, props) {
  log.debug('mapStateToProps(): state & starting props', state, props);
  return {};
}



function mapDispatchersToProps(dispatch) {
  log.debug('mapDispatchersToProps(): ', dispatch);
  return {}
}

// This connects mapStateToProps and mapDispatchersToProps into Redux, effectively plumbing the Page to the app state
export default connect(mapStateToProps, mapDispatchersToProps)(InvoiceProperties);
